export default {
  colors: {
    main: '#32A097',
    secondary: '#525656',
    gray: '#F6F6F6',
    grayContrast: '#EEEEEE',

    text: {
      main: '#FFFFFF',
      secondary: '#FFFFFF',
      gray: '#525656'
    }
  }
}



// WEBPACK FOOTER //
// ./src/theme.js